import React from 'react';
import { Card, Typography, Box } from 'vindi-ds-components';

function SectionCustomerNew({
  children,
  title,
  subtitle,
}) {
  return (
    <Box mb={4}>
      <Card padding='medium'>
        <Box mb={3}>
          <Typography variant='subtitle1'>{title}</Typography>
        </Box>
        {
          subtitle && (
            <Box mb={3}>
              <Typography>
                {subtitle}
              </Typography>
            </Box>
          )
        }
        {children}
      </Card>
    </Box>
  );
}

export default SectionCustomerNew;
